var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payMentDetails" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("customerService.refund_transaction_details"),
            visible: _vm.dialogTableVisible,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            open: _vm.getDetailInfo,
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "total" }, [
                _c("div", { staticClass: "total-item" }, [
                  _c("div", { staticClass: "total-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("customerService.refund_transaction_amount")
                      ) + ":"
                    ),
                  ]),
                  _c("div", { staticClass: "total-num" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$store.getters.currency) +
                        " " +
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.merchantInfo.refund_transaction_amount
                          )
                        )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "line" }),
                _c("div", { staticClass: "total-item" }, [
                  _c("div", { staticClass: "total-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("customerService.refunded_transaction_fee")
                      ) + ":"
                    ),
                  ]),
                  _c("div", { staticClass: "total-num" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$store.getters.currency) +
                        " " +
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            Math.abs(_vm.merchantInfo.refund_transaction_fee)
                          )
                        )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "line" }),
                _c("div", { staticClass: "total-item" }, [
                  _c("div", { staticClass: "total-title" }, [
                    _vm._v(_vm._s(_vm.$t("customerService.refund_fee")) + ":"),
                  ]),
                  _c("div", { staticClass: "total-num" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$store.getters.currency) +
                        " " +
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            Math.abs(_vm.merchantInfo.refund_fee)
                          )
                        )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "section-title mb-12 mt-12" }, [
                _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
              ]),
              _c("div", { staticClass: "line-bottom-1px" }),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("components.create_time"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.transaction_create_time)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("merchantAccount.complete_time"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
                ]),
              ]),
              _c("div", { staticClass: "section-title mb-12 mt-36" }, [
                _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
              ]),
              _c("div", { staticClass: "line-bottom-1px" }),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.refund_transaction_id"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.refund_transaction_id)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.mch_refund_order_id"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.mch_order_id)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.refund_type"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getRefundStatusMapLabel(
                        _vm.merchantInfo.refund_category
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.refund_order_amount"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.this_time_refund_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.refunded_transaction_fee"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.refund_transaction_fee
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.refund_transaction_amount"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.refund_transaction_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.refund_fee"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(_vm.merchantInfo.refund_fee)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.amount_to_receive"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.actual_receive_refund_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.refund_fee_charge_mode"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getTransactionFeeMode(
                        _vm.merchantInfo.refund_fee_split_type
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.refund_reason"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.refund_reason)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.original_transaction_id"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.original_transaction_id)),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("customerService.original_transaction_amount")
                    )
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.original_transaction_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.cumulative_amount_refunded"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("toDivideWithDot")(
                        _vm.merchantInfo.refunded_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "customerService.original_transaction_fee_charge_mode"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getTransactionFeeMode(_vm.merchantInfo.fee_split_type)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.payment_method"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getPayinPaymentMethodMap(
                        _vm.merchantInfo.payment_method
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.payment_channel"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(_vm._s(_vm.merchantInfo.channel_code)),
                ]),
              ]),
              _c(
                "el-tag",
                {
                  staticClass: "payin-status tag-custom",
                  attrs: {
                    type: _vm.getRefundTypeMapType(_vm.merchantInfo.status),
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.getRefundTypeMap(_vm.merchantInfo.status))
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }